export default __webpack_public_path__ + "static/media/news98.a491f14c.jpg";